import { render, staticRenderFns } from "./InfoSubmit.vue?vue&type=template&id=c6be76e4&scoped=true&"
import script from "./InfoSubmit.vue?vue&type=script&lang=js&"
export * from "./InfoSubmit.vue?vue&type=script&lang=js&"
import style0 from "./InfoSubmit.vue?vue&type=style&index=0&id=c6be76e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6be76e4",
  null
  
)

export default component.exports